module.exports = __webpack_public_path__ + "static/media/grabPay.b772157f.png";